import { render, staticRenderFns } from "./MyPlanet.vue?vue&type=template&id=e92e411c&scoped=true"
import script from "./MyPlanet.vue?vue&type=script&lang=js"
export * from "./MyPlanet.vue?vue&type=script&lang=js"
import style0 from "./MyPlanet.vue?vue&type=style&index=0&id=e92e411c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92e411c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e92e411c')) {
      api.createRecord('e92e411c', component.options)
    } else {
      api.reload('e92e411c', component.options)
    }
    module.hot.accept("./MyPlanet.vue?vue&type=template&id=e92e411c&scoped=true", function () {
      api.rerender('e92e411c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/MyPlanet.vue"
export default component.exports